import { getApi } from "./api_instance";

export const transactionsReport = async ({
  fromDate,
  toDate,
  dispatch,
  page,
  pageSize,
  filterData=null,
}) => {
  try {
    const { data } = await getApi({
      apiUrl: `/payments/api/transactions/report?toDate=${toDate}&fromDate=${fromDate}&page=${page}&limit=${pageSize}&filterData=${filterData}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
